<template>
  <div class="group-info">
    <div class="top">
      <p class="p1">
        <icon-price size="max" :priceType="comType == 'book_detail' ? 2 : 1">></icon-price>
        <font>{{info.spell_price | toFixPrice}}</font>
      </p>
      <p class="p2">已拼{{info.alreay_sales_num}}</p>
    </div>
    <div class="bottom">
      <p class="p1">{{info.user_num}}人团</p>
      <p class="p2">
        <icon-price size="mini" :priceType="comType == 'book_detail' ? 2 : 1"></icon-price>
        {{info.price | toFixPrice}}
      </p>
      <p class="p3">{{time | compuTime}}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "GroupInfo",
  props: ["info", "comType"],
  data() {
    return {
      time: 0,
      timer: null
    };
  },
  methods: {
    setTime() {
      this.timer = setInterval(() => {
        this.time--;
      }, 1000);
    }
  },
  destroyed() {
    clearInterval(this.timer);
    this.timer = null;
  },
  watch: {
    info: {
      handler(val) {
        if (val.surp_time) {
          this.time = val.surp_time;
          this.setTime();
        }
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
.group-info {
  height: 128px;
  box-sizing: border-box;
  background: url("../../assets/images/group/group-bg.png") no-repeat;
  background-size: 100% 100%;
  > div {
    display: flex;
    justify-content: space-between;
    align-self: center;
    padding: 0 30px;
  }
  .top {
    padding-top: 10px;
    .p1 {
      font-size: 48px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      line-height: 66px;
    }
    .p2 {
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 66px;
    }
  }
  .bottom {
    .p1 {
      height: 34px;
      line-height: 34px;
      padding: 0 20px;
      background: rgba(255, 255, 255, 1);
      border-radius: 17px;
      margin-right: 20px;
      font-size: 24px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(78, 125, 227, 1);
    }
    .p2 {
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      flex: 1;
      line-height: 36px;
      text-decoration: line-through;
    }
    .p3 {
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 40px;
      padding-left: 30px;
      background: url("../../assets/images/book/time.png") no-repeat center left;
      background-size: 22px 26px;
    }
  }
}
</style>
